module.exports = require('browserify-sha3').SHA3Hash



//////////////////
// WEBPACK FOOTER
// ./~/keccakjs/browser.js
// module id = 245
// module chunks = 0